export interface ContactData {
  hero: {
    title: string;
    subtitle: string;
    mascotImage: string;
    mascotAlt: string;
  };
  channels: {
    title: string;
    subtitle: string;
    whatsapp: {
      name: string;
      value: string;
      description: string;
      cta: string;
      url: string;
    };
    email: {
      title: string;
      value: string;
      description: string;
      cta: string;
      url: string;
    };
    phone: {
      title: string;
      value: string;
      description: string;
      cta: string;
      url: string;
    };
  };
  store: {
    title: string;
    description: string;
    address: string;
    schedule: string;
    mapsUrl: string;
    wazeUrl: string;
    mapsLogo: string;
    wazeLogo: string;
  };
  faq: {
    title: string;
    subtitle: string;
    items: Array<{ question: string; answer: string }>;
  };
  cta: {
    title: string;
    subtitle: string;
    buttonLabel: string;
    buttonUrl: string;
  };
}

export const MOCK_CONTACT: ContactData = {
  hero: {
    title: '¿Cómo podemos ayudarte?',
    subtitle:
      'Estamos aquí para resolver tus dudas, ayudarte con tu pedido o simplemente hablar de cartas.',
    mascotImage: 'images/logo/contact.png',
    mascotAlt: 'Mascota Perrón saludando',
  },
  channels: {
    title: 'Escríbenos por el canal que prefieras',
    subtitle: 'Respondemos lo más rápido posible en todos nuestros canales.',
    whatsapp: {
      name: 'WhatsApp',
      value: '+506 8912-5220',
      description:
        'Consultas, pedidos y seguimiento de envíos. Nuestro canal más rápido.',
      cta: 'Escribir por WhatsApp',
      url: 'https://wa.me/50689125220',
    },
    email: {
      title: 'Correo electrónico',
      value: 'hola@perronstore.com',
      description:
        'Para consultas formales, pedidos especiales o colaboraciones.',
      cta: 'Enviar correo',
      url: 'mailto:hola@perronstore.com',
    },
    phone: {
      title: 'Teléfono',
      value: '+506 8912-5220',
      description:
        'Llámanos en horario de tienda para atención inmediata.',
      cta: 'Llamar ahora',
      url: 'tel:+50689125220',
    },
  },
  store: {
    title: 'Visítanos en persona',
    description:
      'Ven a conocer nuestra tienda, ver producto en persona, participar en eventos o simplemente pasar a saludar.',
    address: 'Plaza Del Castillo Local #17, Zapote, San José, Costa Rica',
    schedule: 'Martes a Domingo, 12:00 pm – 7:00 pm',
    mapsUrl:
      'https://maps.google.com/?q=Plaza+Del+Castillo+Zapote+San+Jose+Costa+Rica',
    wazeUrl: 'https://ul.waze.com/ul?venue_id=180813923.1808466912.25261033',
    mapsLogo: 'images/logo/g_maps_logo.png',
    wazeLogo: 'images/logo/waze_logo.png',
  },
  faq: {
    title: 'Preguntas frecuentes',
    subtitle: 'Las respuestas a lo que más nos preguntan.',
    items: [
      {
        question: '¿Hacen envíos a todo Costa Rica?',
        answer:
          'Sí, hacemos envíos a todas las provincias del país. Trabajamos con servicios de mensajería y encomiendas para que tu pedido llegue lo más rápido posible. Los tiempos y costos varían según la zona.',
      },
      {
        question: '¿Cuánto tarda un envío?',
        answer:
          'En el Gran Área Metropolitana (GAM), los envíos suelen llegar en 1-2 días hábiles. Para zonas rurales, el tiempo estimado es de 3-5 días hábiles.',
      },
      {
        question: '¿Puedo recoger mi pedido en tienda?',
        answer:
          'Por supuesto. Puedes elegir la opción de retiro en tienda al hacer tu pedido y recogerlo en nuestro local en Plaza Del Castillo, Zapote, en horario de atención.',
      },
      {
        question: '¿Los productos son originales?',
        answer:
          'Todos nuestros productos son 100% originales y sellados de fábrica. Trabajamos directamente con distribuidores autorizados para garantizar la autenticidad de cada artículo.',
      },
      {
        question: '¿Tienen envíos entre tiendas?',
        answer:
          'Sí, sólo para singles y para las tiendas con las que tenemos acuerdos, que son las que verás disponibles para este método de envío al momento de realizar tu compra.',
      },
    ],
  },
  cta: {
    title: '¿No encontraste lo que buscabas?',
    subtitle: 'Escríbenos por WhatsApp y te ayudamos al momento.',
    buttonLabel: 'Escribir por WhatsApp',
    buttonUrl: 'https://wa.me/50689125220',
  },
};
